<form [formGroup]="form">
  <div class="p-fluid">
    <kodit-field
      fieldLabelFor="komentar-stavke"
      fieldLabel="Komentar stavke prijemnice"
    >
      <kodit-textarea-input
        formCtrlId="komentar"
        [formCtrl]="form.controls.komentar"
      ></kodit-textarea-input>
    </kodit-field>
  </div>
</form>
